import { forwardRef } from 'react';
import SlickSlider from 'react-slick';
import clsx from 'clsx';
import { SliderProps } from './slider.types';
import { Wrapper } from './slider.styles';

export const SliderArrow = (props: {
  children: JSX.Element;
  slideCount?: number;
  currentSlide?: number;
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { children, currentSlide, slideCount, ...others } = props;

  return <button {...others}>{children}</button>;
};

const Slider: React.ForwardRefRenderFunction<SlickSlider, SliderProps> = (
  { children, settings, className }: SliderProps,
  ref
) => (
  <Wrapper className={clsx(className)}>
    <SlickSlider ref={ref} {...settings}>
      {children}
    </SlickSlider>
  </Wrapper>
);

export default forwardRef(Slider);
